import axios from 'axios';

/**
 * Cria um cliente da API de formulário parametrizado.
 * Substitui o antigo services/api-recebimentoweb.js + store/modules/formulario.js,
 * que dependiam de process.env e do Vuex. Aqui a baseURL e o token vêm por prop.
 *
 * @param {Object} config
 * @param {string} config.baseURL URL base da API do cliente (ex.: https://.../apidevelop)
 * @param {string} [config.token] chave/token enviado como Bearer
 * @returns {Object} métodos da API + a instância axios
 */
export default function createApi({ baseURL, token } = {}) {
  const http = axios.create({ baseURL });
  if (token) http.defaults.headers.Authorization = `Bearer ${token}`;

  return {
    baseURL,
    http,

    // GET formulario/completo/:id  → árvore completa do formulário
    async find(id) {
      const { data } = await http.get(`formulario/completo/${id}`);
      return data;
    },

    // POST formularioresposta/all  → envia respostas novas
    async enviar(payload) {
      const { data } = await http.post('formularioresposta/all', payload);
      return data;
    },

    // PUT formularioresposta/update/all  → atualiza respostas existentes
    async update(payload) {
      const { data } = await http.put('formularioresposta/update/all', payload);
      return data;
    },

    // GET formularioidentificacao/formulario/:id  → o que já foi respondido
    // (1 formulário = 1 pessoa/ocorrência; não depende de CPF)
    async identificado({ id }) {
      const { data } = await http.get(`formularioidentificacao/formulario/${id}`);
      return data;
    },

    // PUT formulario/concluir/:id  → marca fordatafinalizado no formulário
    async concluir({ id }) {
      const { data } = await http.put(`formulario/concluir/${id}`);
      return data;
    },
  };
}
